var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5833 4.61035H19.5V2.30566H17.3333V4.61035H8.66667V2.30566H6.5V4.61035H5.41667C4.21417 4.61035 3.26083 5.64746 3.26083 6.91504L3.25 23.0478C3.25 24.3154 4.21417 25.3525 5.41667 25.3525H20.5833C21.775 25.3525 22.75 24.3154 22.75 23.0478V6.91504C22.75 5.64746 21.775 4.61035 20.5833 4.61035ZM20.5827 23.0469H5.41602V11.5234H20.5827V23.0469ZM20.5827 9.21875H5.41602V6.91406H20.5827V9.21875ZM13.0001 14.9816H18.4168V20.7434H13.0001V14.9816Z",
    fill: "#A0A7B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent);
export default __webpack_public_path__ + "static/media/event.9ad17aece122a895c632047a0b7a7b8d.svg";
export { ForwardRef as ReactComponent };